module.exports = __webpack_public_path__ + "img/nhtsa-logo.b744965d.png";